module.exports = __webpack_public_path__ + "static/media/updating-content.61a6a5a2.png";